import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../web/components-v2/Theme/theme';
import { SETTINGS_SHADOW_SM } from './settingsStyles';

export const categoriesTabStyles = StyleSheet.create({
	toolbar: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: 12,
		marginBottom: 14,
	},
	searchInput: {
		width: 260,
	},
	formFieldSmall: {
		flex: 1,
		minWidth: 120,
	},
	formRow: {
		display: 'flex',
		gap: 16,
		flexWrap: 'wrap' as const,
	},
	textarea: {
		width: '100%',
		padding: '11px 13px',
		fontSize: 14,
		lineHeight: 1.5,
		border: `1px solid ${THEME.colors.border.main}`,
		borderRadius: THEME.common.borderRadius,
		boxShadow: SETTINGS_SHADOW_SM,
		outline: 'none',
		boxSizing: 'border-box' as const,
		fontFamily: 'inherit',
		resize: 'vertical' as const,
		':focus': {
			borderColor: THEME.colors.primary.main,
		},
	},
	checkboxRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
		marginTop: 4,
	},
	checkboxLabel: {
		fontSize: 14,
		color: THEME.colors.text.main,
	},
	categoryItem: {
		borderTop: '2px solid transparent',
		borderBottom: `1px solid ${THEME.colors.border.light}`,
	},
	categoryDropAbove: {
		borderTopColor: THEME.colors.primary.main,
	},
	categoryDropBelow: {
		borderBottomColor: THEME.colors.primary.main,
		borderBottomWidth: 2,
	},
	categoryHeader: {
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		padding: '14px 18px',
		cursor: 'pointer',
		':hover': {
			backgroundColor: THEME.colors.background.main,
		},
	},
	dragHandle: {
		cursor: 'grab',
		color: THEME.colors.text.light,
		fontSize: 16,
		marginRight: 8,
		userSelect: 'none' as const,
		flexShrink: 0,
		':active': {
			cursor: 'grabbing',
		},
	},
	categoryInfo: {
		display: 'flex',
		flexDirection: 'column' as const,
		gap: 2,
		flex: 1,
		minWidth: 0,
	},
	categoryNameRow: {
		display: 'flex',
		alignItems: 'center',
		gap: 8,
	},
	colorSwatch: {
		display: 'inline-block',
		width: 12,
		height: 12,
		borderRadius: '50%',
		flexShrink: 0,
	},
	categoryName: {
		fontSize: 14,
		fontWeight: 600,
		color: THEME.colors.text.main,
	},
	inactiveBadge: {
		display: 'inline-block',
		fontSize: 11,
		padding: '1px 6px',
		borderRadius: 3,
		backgroundColor: THEME.colors.background.main,
		color: THEME.colors.text.light,
		fontWeight: 500,
	},
	aiBadge: {
		display: 'inline-flex',
		alignItems: 'center',
		fontSize: 10,
		fontWeight: 600,
		letterSpacing: 0.4,
		color: THEME.colors.tertiary.dark,
		backgroundColor: THEME.colors.tertiary.light,
		borderRadius: 5,
		padding: '2px 6px',
	},
	categoryDescription: {
		fontSize: 12,
		color: THEME.colors.text.light,
		marginTop: 3,
		lineHeight: 1.45,
		whiteSpace: 'nowrap' as const,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
	},
	categoryActions: {
		marginLeft: 12,
		flexShrink: 0,
	},
});
